import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/cookie-policy", label: "Cookie Policy" },
  { to: "/termini-di-vendita", label: "Termini di Vendita" },
  { to: "/diritto-di-recesso", label: "Diritto di Recesso" },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#05020a] border-t border-[#120a21]">
    <div className="py-12 px-6 border-b border-[#120a21]">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-xs text-[#94a3b8]">
        <div className="space-y-3">
          <Logo compact />
          <p className="leading-relaxed">Focus. Metodo. Costanza.</p>
          <p className="leading-relaxed">Coaching online in tutta Italia • Checkout sicuro Stripe</p>
        </div>
        <div>
          <h3 className="text-white font-bold uppercase tracking-wider mb-3 text-[11px]">Informazioni Legali</h3>
          <ul className="space-y-2">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  to={l.to} className="hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-white font-bold uppercase tracking-wider mb-3 text-[11px]">Contatti</h3>
          <ul className="space-y-2">
            <li>
              <Link data-testid="footer-link-contatti" to="/contatti" className="hover:text-white transition-colors">
                Pagina Contatti
              </Link>
            </li>
            <li>
              <a data-testid="footer-email" href="mailto:mpcoaching.online@gmail.com" className="hover:text-white transition-colors">
                mpcoaching.online@gmail.com
              </a>
            </li>
            <li>
              <a data-testid="footer-phone" href="tel:+393933111439" className="hover:text-white transition-colors">
                Tel: 393 311 1439
              </a>
            </li>
            <li className="text-[#64748b]">Via Fratelli Garrone 79, Torino</li>
            <li className="text-[#64748b]">P.IVA 13527260015</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="py-6 px-6 text-xs text-[#64748b]">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <span>© {new Date().getFullYear()} MP Coaching — Tutti i diritti riservati</span>
        <span>Pagamenti elaborati in sicurezza da Stripe, conformi PCI-DSS</span>
      </div>
    </div>
  </footer>
);
